import styled from "styled-components";
import Colors from "../../Constant/Colors";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  padding: 5px 16px;
  margin: 10px 0px;
  align-items: center;
  width: 85%;
  border-radius: 50px;
  box-shadow: 1px 1px 1px 2px #6662;
  background-color: ${Colors.whiteThemeColor};
  .form-control:focus {
    box-shadow: none !important;
  }
  .form-control {
    border-radius: 0px !important;
  }
`;

export const SearchInput = styled.input`
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  border: none;
  padding: 0;
  margin-left: 8px;
  width: 100%;
  outline: none;
`;
